export default __webpack_public_path__ + "static/media/nanya.5f10c000.jpg";